// extracted by css-extract-rspack-plugin
export default {"codeSpanWithMargin":"rW19qhGUbowATBvc"};